import FavoriteRestaurantIdb from '../../data/favorite-restaurant-idb'
import FavoredRestaurantView from './favored-restaurants/favored-restaurant-view'
import FavoriteRestaurantShowPresenter from './favored-restaurants/favorite-restaurant-show-presenter'

const view = new FavoredRestaurantView()

const Favorite = {
  async render () {
    return view.getTemplate()
  },

  async afterRender () {
    const test = document.querySelector('.test')
    test.style.height = 0

    const loader = document.querySelector('.backdrop')
    loader.style.display = 'none'

    new FavoriteRestaurantShowPresenter({ view, favoriteRestaurants: FavoriteRestaurantIdb })
  }
}

export default Favorite
